import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b050a84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accordion-container" }

import { provideAccordion } from ".";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressAccordion',
  props: {
    multiple: { type: Boolean },
    dense: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



provideAccordion({ multiple: props.multiple, dense: props.dense });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})